export class SearchVenueHelperModel {
    public pageNumber: number = 1;
    public pageSize: number = 15;
    public filter: string = "";
    // public countryCodes: Array<string>;
    // public Location.Latitude = ""
    // public Location.Longitude = ""

}
